export default __webpack_public_path__ + "static/media/ShopperApprovedSeal.1a6846d6.svg";